import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NucleoFamiliarService {

  //private apiUrl = 'http://localhost:3000/api/familiar';
  private apiUrl =  `${environment.apiUrl}/api/familiar`; 

  constructor(private http: HttpClient) {}

  getNucleosFamiliares(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl).pipe(
      catchError(error => {
        console.error('Error al obtener núcleos familiares:', error);
        return throwError(() => new Error('Error al obtener núcleos familiares'));
      })
    );
  }
}
